import { styled } from '@mui/material/styles'

import MenuItem from '@mui/material/MenuItem'

const MenuItemStyled = styled(MenuItem)(() => {
  return {
    minHeight: 'auto',
  }
})

export default MenuItemStyled
